import Vue from 'vue'
import Router from 'vue-router'
import hooks from './hooks'
import Home from '@/components/home/index'
// import BlockListPage from '@/components/blocks/List'
// import BlockDetailPage from '@/components/blocks/Detail'
// import OntIdListPage from '@/components/ontId/List'
// import OntIdDetailPage from '@/components/ontId/Detail'
// import AddressDetailPage from '@/components/addresses/Detail'
// import AddressList from '@/components/addresses/List'
// import TransactionList from '@/components/transactions/List'
// import TransactionDetail from '@/components/transactions/Detail'
// import ClaimDetailPage from '@/components/claim/Detail'
// import ClaimVerifyPage from '@/components/claim/Verify'
// import NodeStakeAuthorization from '@/components/nodes/List'
// import NodeTeamDetail from '@/components/nodes/Detail'
// import ContractList from '@/components/contracts/List'
// import ContractDetail from '@/components/contracts/Detail'
// import TokenList from '@/components/tokens/List'
// import TokenDetail from '@/components/tokens/Detail'
// import StatisticsTable from '@/components/statistics/Table'
// import ContractForm from '@/components/form/ContractForm'

const BlockListPage = () => import('@/components/block/List')
const BlockDetailPage = () => import('@/components/block/Detail')
const OntIdListPage = () => import('@/components/ontid/List')
const OntIdDetailPage = () => import('@/components/ontid/Detail')
const AddressDetailPage = () => import('@/components/address/Detail')
const AddressList = () => import('@/components/address/List')
const TransactionList = () => import('@/components/transaction/List')
const TransactionDetail = () => import('@/components/transaction/Detail')
// const ClaimDetailPage = () => import('@/components/claim/Detail')
// const ClaimVerifyPage = () => import('@/components/claim/Verify')
// const NodeStakeAuthorization = () => import('@/components/nodes/List')
// const NodeTeamDetail = () => import('@/components/nodes/Detail')
const ContractList = () => import('@/components/contract/List')
const ContractDetail = () => import('@/components/contract/Detail')
const ContractSubmit = () => import('@/components/contract/submit')
const Oep4TokenList = () => import('@/components/tokenOep4/List')
const Oep5TokenList = () => import('@/components/tokenOep5/List')
const Oep8TokenList = () => import('@/components/tokenOep8/List')
const TokenList = () => import('@/components/tokens/List')
const TokenDetail = () => import('@/components/tokens/Detail')
const TokenSubmit = () => import('@/components/tokens/submit')
const StatisticsTable = () => import('@/components/statistics/Table')
const TopData = () => import('@/components/top/index')
const UserLogin = () => import('@/components/user/login')
const UserInfo = () => import('@/components/user/index')
// const ContractForm = () => import('@/components/form/ContractForm')
const ExportData = () => import('@/components/export')

Vue.use(Router);

let routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/user/login',
    name: 'Login',
    component: UserLogin
  },
  {
    path: '/user/info/:type',
    name: 'Info',
    component: UserInfo
  },
  {
    path: '/blocks/:pageSize/:pageNumber',
    name: 'blockList',
    component: BlockListPage
  },
  {
    path: '/block/:param',
    name: 'blockDetail',
    component: BlockDetailPage
  },
  {
    path: '/blocks/:pageSize/:pageNumber/:net',
    name: 'blockListDetailTest',
    component: BlockListPage
  },
  {
    path: '/block/:param/:net',
    name: 'blockDetailTest',
    component: BlockDetailPage
  },
  {
    path: '/ontidlist/:pageSize/:pageNumber',
    name: 'OntIdList',
    component: OntIdListPage
  },
  {
    path: '/ontid/:ontid/:pageSize/:pageNumber',
    name: 'OntIdDetail',
    component: OntIdDetailPage
  },
  {
    path: '/ontid/:ontid',
    name: 'OntIdDetailWithoutPage',
    component: OntIdDetailPage
  },
  {
    path: '/address/analytics/:address/:analyticsType',
    name: 'AddressAnalyticsDetail',
    component: AddressDetailPage
  },
  {
    path: '/address/analytics/:address/:analyticsType/:net',
    name: 'AddressAnalyticsDetail',
    component: AddressDetailPage
  },
  {
    path: '/address/:address/:assetName/:pageSize/:pageNumber',
    name: 'AddressDetail',
    component: AddressDetailPage
  },
  {
    path: '/address/:address/:pageSize/:pageNumber',
    name: 'AddressDetail',
    component: AddressDetailPage
  },
  {
    path: '/addresses/:token/:pageSize/:pageNumber',
    name: 'addressList',
    component: AddressList
  },
  {
    path: '/addresses/:token/:pageSize/:pageNumber/:net',
    name: 'addressListTest',
    component: AddressList
  },
  {
    path: '/transactions/:pageSize/:pageNumber',
    name: 'TransactionList',
    component: TransactionList
  },
  {
    path: '/transactions/:pageSize/:pageNumber/:net',
    name: 'TransactionListTest',
    component: TransactionList
  },
  {
    path: '/transaction/:tx_hash',
    name: 'TransactionDetail',
    component: TransactionDetail
  },
  {
    path: '/transaction/:tx_hash/:net',
    name: 'TransactionDetailTest',
    component: TransactionDetail
  },
  //   {
  //     path: '/claimverify/:cardId/:ownerOntId',
  //     name: 'ClaimDetai',
  //     component: ClaimDetailPage
  //   },
  //   {
  //     path: '/claimverifyresult',
  //     name: 'ClaimVerify',
  //     component: ClaimVerifyPage
  //   },
  {
    path: '/:net',
    name: 'HomeTest',
    component: Home
  },
  {
    path: '/ontidlist/:pageSize/:pageNumber/:net',
    name: 'OntIdListDetailTest',
    component: OntIdListPage
  },
  {
    path: '/ontid/:ontid/:pageSize/:pageNumber/:net',
    name: 'OntIdDetailTest',
    component: OntIdDetailPage
  },
  {
    path: '/address/:address/:assetName/:pageSize/:pageNumber/:net',
    name: 'AddressDetailTest',
    component: AddressDetailPage
  },
  {
    path: '/address/:address/:pageSize/:pageNumber/:net',
    name: 'AddressDetailTest',
    component: AddressDetailPage
  },
  {
    path: '/address/:address/:net',
    name: 'AddressDetailTest',
    component: AddressDetailPage
  },
  //   {
  //     path: '/claimverify/:cardId/:ownerOntId/:net',
  //     name: 'ClaimDetaiTest',
  //     component: ClaimDetailPage
  //   },
  //   {
  //     path: '/claimverifyresult/:net',
  //     name: 'ClaimVerifyTest',
  //     component: ClaimVerifyPage
  //   },
  //   {
  //     path: '/nodes/list',
  //     name: 'NodeStakeList',
  //     component: NodeStakeAuthorization
  //   },
  //   {
  //     path: '/nodes/detail/:pk',
  //     name: 'NodeTeamDetail',
  //     component: NodeTeamDetail
  //   },
  //   {
  //     path: '/nodes/list/:net',
  //     name: 'NodeStakeListTestNet',
  //     component: NodeStakeAuthorization
  //   },
  {
    path: '/contract/list/:pageSize/:pageNumber',
    name: 'ContractList',
    component: ContractList
  },
  {
    path: '/contract/list/:pageSize/:pageNumber/:net',
    name: 'ContractListTest',
    component: ContractList
  },
  /*   {
      path: '/contract/analytics/:contractHash/:analyticsType',
      name: 'ContractAnalytics',
      component: ContractDetail
    }, */
  {
    path: '/contract/:contractType/:contractHash/:pageSize/:pageNumber',
    name: 'ContractDetail',
    component: ContractDetail
  },
  {
    path: '/contract/:contractType/:contractHash',
    name: 'ContractDetailwithoutpage',
    component: ContractDetail
  },
  /*   {
      path: '/contract/:contractType/:contractHash/:pageSize',
      name: 'ContractDetailwithoutpageSize',
      component: ContractDetail
    }, */
  {
    path: '/contract/:contractHash/:pageSize/:pageNumber',
    name: 'ContractDetailwithoutType',
    component: ContractDetail
  },
  {
    path: '/contract/:contractHash',
    name: 'ContractDetailOnlyHash',
    component: ContractDetail
  },
  {
    path: '/contract/:contractType/:contractHash/:pageSize/:pageNumber/:net',
    name: 'ContractDetailTest',
    component: ContractDetail
  },
  /*   {
      path: '/contract/RegistrationForm',
      name: 'ContractRegistrationForm',
      component: ContractRegistrationForm
    },
    {
      path: '/contract/RegistrationForm/:net',
      name: 'ContractRegistrationFormTest',
      component: ContractRegistrationForm
    }, */
  {
    path: '/token/list/:contractType/:pageSize/:pageNumber',
    name: 'TokenList',
    component: TokenList
  },
  {
    path: '/token/list/:contractType/:pageSize/:pageNumber/:net',
    name: 'TokenListTest',
    component: TokenList
  },
  {
    path: '/token/detail/:contractType/:contractHash/:tokenName/:pageSize/:pageNumber',
    name: 'TokenDetail',
    component: TokenDetail
  },
  {
    path: '/token/detail/:contractType/:contractHash',
    name: 'TokenAnalytics',
    component: TokenDetail
  },
  {
    path: '/token/detail/:contractType/:contractHash/:tokenName/:pageSize/:pageNumber/:net',
    name: 'TokenDetailTest',
    component: TokenDetail
  },
  {
    path: '/token/detail/:contractType/:contractHash/:net',
    name: 'TokenAnalytics',
    component: TokenDetail
  },
  {
    path: '/token/submit',
    name: 'TokenSubmit',
    component: TokenSubmit
  },
  {
    path: '/token/submit/:net',
    name: 'TokenSubmitTest',
    component: TokenSubmit
  },
  {
    path: '/statistics/:day',
    name: 'Statistics',
    component: StatisticsTable
  },
  {
    path: '/statistics/:day/:net',
    name: 'StatisticsTest',
    component: StatisticsTable
  },
  {
    path: '/top/:topType/:topDuration',
    name: 'TopData',
    component: TopData
  },
  {
    path: '/top/:topType/:topDuration/:net',
    name: 'TopDataTest',
    component: TopData
  },
  //   {
  //     path: '/statistics/contract/:contractHash/:day',
  //     name: 'StatisticsContract',
  //     component: StatisticsTable
  //   },
  //   {
  //     path: '/statistics/contract/:contractHash/:day/:net',
  //     name: 'StatisticsContractTest',
  //     component: StatisticsTable
  //   },
  //   {
  //     path: '/form/contractform',
  //     name: 'ContractForm',
  //     component: ContractForm
  //   },
  //   {
  //     path: '/addresses/:pageSize/:pageNumber/:net',
  //     name: 'ContractFormTest',
  //     component: ContractForm
  //   },
  {
    path: '/:net?/address/:address/',
    name: 'Address',
    component: AddressDetailPage
  },
  {
    path: '/:net?/token/:contractHash',
    name: 'Token',
    component: TokenDetail
  },
  {
    path: '/contracts/submit',
    name: 'ContractSubmit',
    component: ContractSubmit
  },
  {
    path: '/contracts/submit/:net',
    name: 'ContractSubmitTest',
    component: ContractSubmit
  },
  {
    path: '/:net?/exportData/:address',
    name: 'ExportData',
    component: ExportData
  },
];


// 兼容EIP-3091规范
// https://github.com/ethereum-lists/chains/pull/331 ，https://eips.ethereum.org/EIPS/eip-3091
const redirectRules = [];

routes.forEach((r) => {
  const path = r.path;
  const len = path.length;
  let targetStr = '/:net';
  let redirectPath = path;

  const redirectMap = {
    "/transaction/": "/tx/",
    "/transactions/": "/txs/",
    "/token/list/": "/tokens/",
    "/token/detail/": "/token/",
    "/contract/list/": "/contracts/",
    "/token/submit": "/tokens/submit",
 }

  // String.prototype.endsWith
  if (path.substring(len - targetStr.length, len) === targetStr && path !== targetStr) {
    redirectPath = `${targetStr}${path.substring(0, len - targetStr.length)}`;
  }
  Object.keys(redirectMap).forEach((key) => {
    redirectPath = redirectPath.replace(key, redirectMap[key])
  })

  if (redirectPath !== path) {
    redirectRules.push({
      ...r,
      name: `${r.name}Normalized`,
      path: redirectPath
    })
    r.redirect = redirectPath
  }
})

// console.log(routes.concat(redirectRules));

const router = new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    return to.name === from.name ? savedPosition : { y: 0 };
  },
  routes: routes.concat(redirectRules)
});


export default router


Vue.use(hooks);




// WEBPACK FOOTER //
// ./src/router/index.js